module.exports = __webpack_public_path__ + "img/delete_24.4278627e.svg";